// Others
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import axiosClient from './axiosClient';
import { urlApiQuote } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate, IFileItem, IQueryParamBase } from '~/utils/interface/common';
import {
  IBodyChangeStatusQuote,
  ICloneQuote,
  IOverbookedItemDetail,
  IQueryParamQuote,
  IQueryParamQuoteDetail,
  IQuoteDetail,
  IQuotes,
} from '~/utils/interface/quotes';

const quoteApi = {
  getListQuote: (params: IQueryParamQuote) => {
    const url = urlApiQuote.getListQuote;
    return axiosClient.get<IBaseResponse<IListDataResponse<IQuotes[]>>>(url, { params });
  },

  getDetailQuote: (params: IQueryParamQuoteDetail) => {
    const { quoteId, type, query } = params;
    const url = urlApiQuote.getDetailQuote(quoteId, type);
    return axiosClient.get<IBaseResponse<IListDataResponse<IFileItem[]> | IQuoteDetail | IOverbookedItemDetail>>(url, {
      params: query,
    });
  },

  createQuote: (formData: FormData) => {
    const url = urlApiQuote.createQuote;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  updateQuote: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiQuote.updateQuote(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteQuote: (id: string) => {
    const url = urlApiQuote.deleteQuote(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  convertQuoteToOrder: (id: string) => {
    const url = urlApiQuote.convertQuoteToOrder(id);
    return axiosClient.post<IBaseResponse>(url);
  },

  changeStatusQuote: (params: IBodyChangeStatusQuote) => {
    const { quoteId, status } = params;
    const url = urlApiQuote.changeStatusQuote(quoteId);
    return axiosClient.put<IBaseResponse>(url, { status });
  },

  cloneQuote: (body: ICloneQuote) => {
    const url = urlApiQuote.cloneQuote;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  sendMailQuote: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;

    const url = urlApiQuote.sendMailQuote(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default quoteApi;
